import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  class: "mb-5",
  style: {"background-color":"var(--color-light-light-gray)","padding":"20px"}
}
const _hoisted_2 = { class: "h5 fw-bold mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "mb-1" }
const _hoisted_5 = { class: "mb-1" }
const _hoisted_6 = ["innerHTML"]
const _hoisted_7 = { class: "col-md-6" }
const _hoisted_8 = { class: "mb-1" }
const _hoisted_9 = { style: {"color":"var(--description-color)"} }
const _hoisted_10 = { class: "mb-1" }
const _hoisted_11 = { style: {"color":"var(--description-color)"} }
const _hoisted_12 = { class: "mb-1" }
const _hoisted_13 = { style: {"color":"var(--description-color)"} }
const _hoisted_14 = { class: "col-md-6" }
const _hoisted_15 = { class: "mb-1" }
const _hoisted_16 = { style: {"color":"var(--description-color)"} }
const _hoisted_17 = { class: "mb-1" }
const _hoisted_18 = { style: {"color":"var(--description-color)"} }
const _hoisted_19 = {
  key: 0,
  class: "mt-1"
}
const _hoisted_20 = { style: {"font-size":"10.2px","line-height":"1.2","display":"block"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.title")), 1),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("p", _hoisted_5, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.description")) + ": ", 1),
          _createElementVNode("span", {
            innerHTML: 
            _ctx.$t(
              `project.previewAndReport.reportTypes.complete_solution.installment.projectInfo.description`,
              {
                phase: `<span style='color: var(--description-color);'>${_ctx.$t(`project.previewAndReport.phaseTypes.${_ctx.projectData?.phase_type||'single'}`)}</span>`,
                power: `<span style='color: var(--description-color);'>${_ctx.projectData?.total_power || '0'}</span>`,
                battery: `<span style='color: var(--description-color);'>${_ctx.projectData?.total_battery || '0'}</span>`,
              }
            )
          
          }, null, 8, _hoisted_6)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.clientName")) + ": ", 1),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.projectData?.client_name || "N/A"), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.totalPower")) + ": ", 1),
          _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.projectData?.total_power || "0"), 1),
          _cache[0] || (_cache[0] = _createTextVNode(" kW "))
        ]),
        _createElementVNode("div", _hoisted_12, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.annualProduction")) + ": ", 1),
          _createElementVNode("span", _hoisted_13, _toDisplayString(new Intl.NumberFormat("en-EU", {}).format(
              _ctx.projectData?.annual_production || 0
            )), 1),
          _cache[1] || (_cache[1] = _createTextVNode(" kWh "))
        ])
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.address")) + ": ", 1),
          _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.projectAddress), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.totalBattery")) + ": ", 1),
          _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.projectData?.total_battery || "0"), 1),
          _cache[2] || (_cache[2] = _createTextVNode(" kWh "))
        ])
      ])
    ]),
    (_ctx.projectData?.note)
      ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
          _createElementVNode("small", _hoisted_20, [
            _createElementVNode("strong", null, _toDisplayString(_ctx.$t("project.previewAndReport.projectInfo.note")) + ":", 1),
            _createTextVNode(" " + _toDisplayString(_ctx.projectData.note), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}